// src/data/SeoData.js

const SeoData = {
  donate: {
    title: "Donate to M.C Bridge of Hope | Support Community & Youth Programs",

    meta: [
      {
        name: "description",
        content:
          "Donate to M.C Bridge of Hope and support practical care, outreach, youth empowerment programs, community support, and future initiatives.",
      },

      {
        name: "author",
        content: "M.C Bridge of Hope",
      },

      {
        name: "robots",
        content:
          "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
      },

      {
        property: "og:title",
        content:
          "Donate to M.C Bridge of Hope | Support Community & Youth Programs",
      },

      {
        property: "og:description",
        content:
          "Give hope through a one-off donation supporting practical care, outreach, community programs, and youth empowerment.",
      },

      {
        property: "og:type",
        content: "website",
      },

      {
        property: "og:url",
        content: "https://marychan.org.au/donate",
      },

      {
        property: "og:image",
        content: "https://marychan.org.au/images/mary-chan-social-share.jpg",
      },

      {
        property: "og:image:alt",
        content: "M.C Bridge of Hope donation and community support",
      },

      {
        property: "og:site_name",
        content: "M.C Bridge of Hope",
      },

      {
        property: "og:locale",
        content: "en_AU",
      },

      {
        name: "twitter:card",
        content: "summary_large_image",
      },

      {
        name: "twitter:title",
        content:
          "Donate to M.C Bridge of Hope | Support Community & Youth Programs",
      },

      {
        name: "twitter:description",
        content:
          "Support practical care, outreach, youth programs, and community initiatives through a secure one-off donation.",
      },

      {
        name: "twitter:image",
        content: "https://marychan.org.au/images/mary-chan-social-share.jpg",
      },
    ],

    link: [
      {
        rel: "canonical",
        href: "https://marychan.org.au/donate",
      },

      {
        rel: "alternate",
        hrefLang: "en-au",
        href: "https://marychan.org.au/donate",
      },

      {
        rel: "alternate",
        hrefLang: "x-default",
        href: "https://marychan.org.au/donate",
      },
    ],

    script: [
      {
        type: "application/ld+json",

        children: JSON.stringify({
          "@context": "https://schema.org",

          "@graph": [
            {
              "@type": "Organization",

              "@id": "https://marychan.org.au/#organization",

              name: "M.C Bridge of Hope",

              url: "https://marychan.org.au/",

              logo: "https://marychan.org.au/images/logo.png",

              description:
                "M.C Bridge of Hope supports practical care, community outreach, youth empowerment and leadership programs in Australia.",

              areaServed: {
                "@type": "Country",

                name: "Australia",
              },
            },

            {
              "@type": "WebSite",

              "@id": "https://marychan.org.au/#website",

              url: "https://marychan.org.au/",

              name: "M.C Bridge of Hope",

              publisher: {
                "@id": "https://marychan.org.au/#organization",
              },

              inLanguage: "en-AU",
            },

            {
              "@type": "DonateAction",

              "@id": "https://marychan.org.au/donate#donate-action",

              name: "Donate to M.C Bridge of Hope",

              description:
                "Make a secure one-off donation to support community care, outreach support, and youth programs.",

              recipient: {
                "@id": "https://marychan.org.au/#organization",
              },

              target: {
                "@type": "EntryPoint",

                urlTemplate: "https://marychan.org.au/donate",

                actionPlatform: [
                  "https://schema.org/DesktopWebPlatform",
                  "https://schema.org/MobileWebPlatform",
                ],
              },
            },

            {
              "@type": "WebPage",

              "@id": "https://marychan.org.au/donate#webpage",

              url: "https://marychan.org.au/donate",

              name: "Donate to M.C Bridge of Hope | Support Community & Youth Programs",

              description:
                "Donate to M.C Bridge of Hope and support practical care, outreach, youth empowerment programs, community support, and future initiatives.",

              isPartOf: {
                "@id": "https://marychan.org.au/#website",
              },

              about: {
                "@id": "https://marychan.org.au/#organization",
              },

              inLanguage: "en-AU",
            },

            {
              "@type": "BreadcrumbList",

              "@id": "https://marychan.org.au/donate#breadcrumb",

              itemListElement: [
                {
                  "@type": "ListItem",

                  position: 1,

                  name: "Home",

                  item: "https://marychan.org.au/",
                },

                {
                  "@type": "ListItem",

                  position: 2,

                  name: "Donate",

                  item: "https://marychan.org.au/donate",
                },
              ],
            },
          ],
        }),
      },
    ],
  },
};

export default SeoData;
